import EventPublishModal from './EventPublishModal'

export default EventPublishModal
